import _ from 'lodash';
import * as React from 'react';
import { Container } from 'types/Watchlist';
import { centsToDollars } from 'utils/container-transforms';
import { DualCell } from './DualCell';
import { CellProps } from './types';

export const EstSavings: React.FC<CellProps> = (props) => {
  const container: Container = props.row;

  const savings = container.latestPerDiemCalculation?.estSavingsCents;
  const topText = _.isFinite(savings) ? centsToDollars(savings as number, false) : '';

  return <DualCell topText={topText} showBottomText />;
};
EstSavings.displayName = 'ContainerTable.EstSavings';
